import React from 'react';
import { MessageCircle, X } from 'lucide-react';

export function ChatHeader({ chat, onClose }) {
  return (
    <div className="bg-[#0047AB] text-white px-4 py-3 flex items-center justify-between shrink-0">
      <div className="flex items-center gap-2">
        <MessageCircle className="w-4 h-4" />
        <div>
          <p className="text-sm font-semibold">Support Chat</p>
          <p className="text-[10px] opacity-70">{chat?.escalated ? 'Connected to admin' : 'AI Assistant'}</p>
        </div>
      </div>
      <button onClick={onClose} className="p-1 hover:bg-white/20 rounded transition-colors" data-testid="close-support-chat">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
